




























































import {Component, Vue} from "vue-property-decorator";
import BaseOverview, {Loadable,} from "@/resources/components/BaseOverview.vue";
import Question from "@/app/models/Question";
import {TranslateResult} from 'vue-i18n';
import Station from '@/app/models/Station';

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})
export default class Index extends Vue {
    $refs!: {
        overview: BaseOverview;
    };
    station: Station = new Station({});

    async mounted() {
        this.station = await Station.show(parseInt(this.$route.params.station)) as Station
    }

    async loadItems(loadable: Loadable) {
        const station_id = this.$route.params.station;

        loadable.loadItems(
            (await Question.index(loadable.page, {station_id})).data
        );
    }

    boolean(value: boolean): TranslateResult {
        return this.$t(value ? "Ja" : "Nee");
    }

    reset() {
        this.$refs.overview.reset();
    }
}
